import React from 'react';

const BecomeMember: React.FC = () => {
  return (
    <section className="card" aria-labelledby="become-member">
      <h3 id="become-member">Become a Member</h3>
      <p>Sign up to get early access, <span className="bold-text">discounts</span>, and community perks. Our Membership is FREE!</p>
      <a href='/registermember' className="btn-default" aria-label="Sign up to become a member">Join Community</a>
    </section>
  );
};

export default BecomeMember;